import { render, staticRenderFns } from "./FreightOrderList.vue?vue&type=template&id=20dc6062&"
import script from "./FreightOrderList.vue?vue&type=script&lang=js&"
export * from "./FreightOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports